import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initI18n } from './i18n';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element in index.html');
}

// i18n init je teď async (lazy-loaduje jen aktivní jazyk). Počkáme na něj před renderem,
// jinak by se na první frame zobrazily překladové klíče místo textů.
void initI18n().finally(() => {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
